import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Notar la extrañeza",
    opening: localizedGenderNode(
      [
      "Hoy no intento cambiarla.",
      "Solo noto la extrañeza tal como es.",
      "Eso es suficiente por ahora."
    ],
      [
      "Hoy no intento cambiarla.",
      "Solo noto la extrañeza tal como es.",
      "Eso es suficiente por ahora."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo se siente más la extrañeza?",
      "¿Qué está pasando a mi alrededor entonces?",
      "¿Cómo se siente en mi cuerpo?"
    ],
      [
      "¿Cuándo se siente más la extrañeza?",
      "¿Qué está pasando a mi alrededor entonces?",
      "¿Cómo se siente en mi cuerpo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Notar la extrañeza ya es una conexión suave."
    ],
      [
      "Notar la extrañeza ya es una conexión suave."
    ]
    ),
    action: localizedGenderNode(
      "una respiración con las palabras \"Estoy aquí\".",
      "una respiración con las palabras \"Estoy aquí\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "Qué extraño aquí",
    opening: localizedGenderNode(
      [
      "Hoy noto lo que extraño aquí.",
      "Sin comparación.",
      "Solo sentir."
    ],
      [
      "Hoy noto lo que extraño aquí.",
      "Sin comparación.",
      "Solo sentir."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento el pecho."
    ],
      [
      "Respiro despacio.",
      "Siento el pecho."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué extraño de mi antiguo hogar?",
      "¿Qué me gustaría tener aquí?",
      "¿Qué me cuesta pedir?"
    ],
      [
      "¿Qué extraño de mi antiguo hogar?",
      "¿Qué me gustaría tener aquí?",
      "¿Qué me cuesta pedir?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una falta pequeña explica mucho."
    ],
      [
      "Una falta pequeña explica mucho."
    ]
    ),
    action: localizedGenderNode(
      "escribir una palabra sobre lo que falta.",
      "escribir una palabra sobre lo que falta."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Lo que traigo conmigo",
    opening: localizedGenderNode(
      [
      "Hoy recuerdo lo que traigo conmigo.",
      "No para perderlo.",
      "Solo recordar."
    ],
      [
      "Hoy recuerdo lo que traigo conmigo.",
      "No para perderlo.",
      "Solo recordar."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué cosa del hogar permanece en mí?",
      "¿Qué en mí no ha cambiado?",
      "¿Cómo se siente recordar eso?"
    ],
      [
      "¿Qué cosa del hogar permanece en mí?",
      "¿Qué en mí no ha cambiado?",
      "¿Cómo se siente recordar eso?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Traer algo del hogar es un ancla."
    ],
      [
      "Traer algo del hogar es un ancla."
    ]
    ),
    action: localizedGenderNode(
      "escribir una cosa que traigo conmigo.",
      "escribir una cosa que traigo conmigo."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Pequeños momentos de pertenencia",
    opening: localizedGenderNode(
      [
      "Hoy busco pequeños momentos de pertenencia.",
      "Aunque sean breves.",
      "Existen."
    ],
      [
      "Hoy busco pequeños momentos de pertenencia.",
      "Aunque sean breves.",
      "Existen."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento mis pies."
    ],
      [
      "Respiro despacio.",
      "Siento mis pies."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo sentí una gota de pertenencia aquí?",
      "¿Qué me permitió sentirla?",
      "¿Cómo se siente en mi cuerpo?"
    ],
      [
      "¿Cuándo sentí una gota de pertenencia aquí?",
      "¿Qué me permitió sentirla?",
      "¿Cómo se siente en mi cuerpo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Incluso una gota de pertenencia cambia algo."
    ],
      [
      "Incluso una gota de pertenencia cambia algo."
    ]
    ),
    action: localizedGenderNode(
      "recordar un momento así.",
      "recordar un momento así."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "El miedo a equivocarme aquí",
    opening: localizedGenderNode(
      [
      "Hoy observo el miedo a equivocarme.",
      "No para pelear.",
      "Solo ver."
    ],
      [
      "Hoy observo el miedo a equivocarme.",
      "No para pelear.",
      "Solo ver."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿De qué tengo miedo aquí?",
      "¿Qué creo que pasará si me equivoco?",
      "¿Cómo me protege este miedo?"
    ],
      [
      "¿De qué tengo miedo aquí?",
      "¿Qué creo que pasará si me equivoco?",
      "¿Cómo me protege este miedo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "El miedo aquí también es un deseo de pertenecer."
    ],
      [
      "El miedo aquí también es un deseo de pertenecer."
    ]
    ),
    action: localizedGenderNode(
      "decirme \"Te veo\".",
      "decirme \"Te veo\"."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Un paso pequeño de visibilidad",
    opening: localizedGenderNode(
      [
      "Hoy elijo un paso pequeño de visibilidad.",
      "No grande.",
      "Pequeño."
    ],
      [
      "Hoy elijo un paso pequeño de visibilidad.",
      "No grande.",
      "Pequeño."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro.",
      "Estoy aquí."
    ],
      [
      "Respiro.",
      "Estoy aquí."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué paso pequeño puedo dar?",
      "¿Qué se sentirá lo suficientemente seguro?",
      "¿Cómo me va a proteger?"
    ],
      [
      "¿Qué paso pequeño puedo dar?",
      "¿Qué se sentirá lo suficientemente seguro?",
      "¿Cómo me va a proteger?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un paso pequeño es suficiente para empezar."
    ],
      [
      "Un paso pequeño es suficiente para empezar."
    ]
    ),
    action: localizedGenderNode(
      "elegir un paso pequeño y recordarlo.",
      "elegir un paso pequeño y recordarlo."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Quedarme un momento más",
    opening: localizedGenderNode(
      [
      "Hoy practico quedarme un momento más en un lugar nuevo.",
      "No huir tan rápido.",
      "Solo un momento."
    ],
      [
      "Hoy practico quedarme un momento más en un lugar nuevo.",
      "No huir tan rápido.",
      "Solo un momento."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo me retiro demasiado rápido?",
      "¿Qué me asusta si me quedo?",
      "¿Qué pasa si me quedo 10 segundos más?"
    ],
      [
      "¿Cuándo me retiro demasiado rápido?",
      "¿Qué me asusta si me quedo?",
      "¿Qué pasa si me quedo 10 segundos más?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un momento más puede abrir una puerta."
    ],
      [
      "Un momento más puede abrir una puerta."
    ]
    ),
    action: localizedGenderNode(
      "pausar 10 segundos antes de retirarme.",
      "pausar 10 segundos antes de retirarme."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Un pequeño lugar para conocerse",
    opening: localizedGenderNode(
      [
      "Hoy observo un pequeño lugar para conocerse.",
      "No mucho.",
      "Un poco."
    ],
      [
      "Hoy observo un pequeño lugar para conocerse.",
      "No mucho.",
      "Un poco."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento el corazón."
    ],
      [
      "Respiro despacio.",
      "Siento el corazón."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Dónde podría sentirme un poco más cerca?",
      "¿Qué me da seguridad allí?",
      "¿Qué paso pequeño puedo dar?"
    ],
      [
      "¿Dónde podría sentirme un poco más cerca?",
      "¿Qué me da seguridad allí?",
      "¿Qué paso pequeño puedo dar?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una cercanía pequeña puede empezar aquí."
    ],
      [
      "Una cercanía pequeña puede empezar aquí."
    ]
    ),
    action: localizedGenderNode(
      "notar un lugar pequeño que se sienta seguro.",
      "notar un lugar pequeño que se sienta seguro."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Una palabra en mi idioma",
    opening: localizedGenderNode(
      [
      "Hoy traigo una palabra en mi idioma.",
      "Como un ancla.",
      "Una palabra."
    ],
      [
      "Hoy traigo una palabra en mi idioma.",
      "Como un ancla.",
      "Una palabra."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué palabra me devuelve a casa?",
      "¿Cuándo decirla me hace bien?",
      "¿Cómo se siente en mi cuerpo?"
    ],
      [
      "¿Qué palabra me devuelve a casa?",
      "¿Cuándo decirla me hace bien?",
      "¿Cómo se siente en mi cuerpo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una palabra puede ser un pequeño hogar."
    ],
      [
      "Una palabra puede ser un pequeño hogar."
    ]
    ),
    action: localizedGenderNode(
      "decir la palabra en mi corazón una vez.",
      "decir la palabra en mi corazón una vez."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Una petición pequeña",
    opening: localizedGenderNode(
      [
      "Hoy formulo una petición pequeña para mí.",
      "Sin drama.",
      "Una petición."
    ],
      [
      "Hoy formulo una petición pequeña para mí.",
      "Sin drama.",
      "Una petición."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro.",
      "Estoy aquí."
    ],
      [
      "Respiro.",
      "Estoy aquí."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué me gustaría que ocurra aquí?",
      "¿Cómo puedo pedirlo con suavidad?",
      "¿Cuál es un paso pequeño hacia eso?"
    ],
      [
      "¿Qué me gustaría que ocurra aquí?",
      "¿Cómo puedo pedirlo con suavidad?",
      "¿Cuál es un paso pequeño hacia eso?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una petición puede abrir una puerta."
    ],
      [
      "Una petición puede abrir una puerta."
    ]
    ),
    action: localizedGenderNode(
      "escribir la petición en una frase.",
      "escribir la petición en una frase."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Una cosa pequeña que sostiene",
    opening: localizedGenderNode(
      [
      "Hoy noto una cosa pequeña que me sostiene aquí.",
      "Aunque sea pequeña.",
      "Eso es suficiente."
    ],
      [
      "Hoy noto una cosa pequeña que me sostiene aquí.",
      "Aunque sea pequeña.",
      "Eso es suficiente."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué me sostiene en los días difíciles aquí?",
      "¿Quién o qué me da una gota de estabilidad?",
      "¿Cómo se siente tener algo así?"
    ],
      [
      "¿Qué me sostiene en los días difíciles aquí?",
      "¿Quién o qué me da una gota de estabilidad?",
      "¿Cómo se siente tener algo así?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Algo pequeño puede ser un ancla."
    ],
      [
      "Algo pequeño puede ser un ancla."
    ]
    ),
    action: localizedGenderNode(
      "sostener algo que me calme un momento.",
      "sostener algo que me calme un momento."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Estar conmigo aquí",
    opening: localizedGenderNode(
      [
      "Hoy practico estar conmigo incluso aquí.",
      "No huir.",
      "Solo estar."
    ],
      [
      "Hoy practico estar conmigo incluso aquí.",
      "No huir.",
      "Solo estar."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento mis pies."
    ],
      [
      "Respiro despacio.",
      "Siento mis pies."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué me devuelve a mí aquí?",
      "¿Qué me saca de mí aquí?",
      "¿Qué podría ayudarme a quedarme?"
    ],
      [
      "¿Qué me devuelve a mí aquí?",
      "¿Qué me saca de mí aquí?",
      "¿Qué podría ayudarme a quedarme?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Estar conmigo aquí ya es pertenencia."
    ],
      [
      "Estar conmigo aquí ya es pertenencia."
    ]
    ),
    action: localizedGenderNode(
      "una respiración en cualquier lugar extraño.",
      "una respiración en cualquier lugar extraño."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Un paso pequeño de pertenencia",
    opening: localizedGenderNode(
      [
      "Hoy elijo un paso pequeño de pertenencia.",
      "Sin drama.",
      "Un paso pequeño."
    ],
      [
      "Hoy elijo un paso pequeño de pertenencia.",
      "Sin drama.",
      "Un paso pequeño."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué paso pequeño estoy dispuesto/a a intentar?",
      "¿Qué se sentirá lo suficientemente seguro?",
      "¿Cómo me va a proteger?"
    ],
      [
      "¿Qué paso pequeño estoy dispuesto/a a intentar?",
      "¿Qué se sentirá lo suficientemente seguro?",
      "¿Cómo me va a proteger?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un paso pequeño es suficiente para acercarme."
    ],
      [
      "Un paso pequeño es suficiente para acercarme."
    ]
    ),
    action: localizedGenderNode(
      "elegir un paso pequeño y recordarlo.",
      "elegir un paso pequeño y recordarlo."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Frase de regreso",
    opening: localizedGenderNode(
      [
      "Hoy elijo una frase que me devuelve a la pertenencia.",
      "Cuando me siento extraño/a.",
      "Una frase pequeña."
    ],
      [
      "Hoy elijo una frase que me devuelve a la pertenencia.",
      "Cuando me siento extraño/a.",
      "Una frase pequeña."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro.",
      "Estoy aquí."
    ],
      [
      "Respiro.",
      "Estoy aquí."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué aprendí sobre esta extrañeza?",
      "¿Cuál es la primera señal de que vuelve?",
      "¿Qué frase me devuelve un momento antes?"
    ],
      [
      "¿Qué aprendí sobre esta extrañeza?",
      "¿Cuál es la primera señal de que vuelve?",
      "¿Qué frase me devuelve un momento antes?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Puedo sentirme extraño/a y aun así quedarme conmigo."
    ],
      [
      "Puedo sentirme extraño/a y aun así quedarme conmigo."
    ]
    ),
    action: localizedGenderNode(
      "decir la nueva frase una vez.",
      "decir la nueva frase una vez."
    ),
  },
].map(buildNormalizedDay);

export const feelingForeignInANewCountryCultureBlueprintEs = buildNormalizedPilotBlueprint({
  id: "feeling_foreign_in_a_new_country_culture_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "feeling_foreign_in_a_new_country_culture",
  category: "loneliness_belonging",
  journeyName: {
    he: "תחושת זרות במדינה / תרבות חדשה",
    en: "Feeling foreign in a new country / culture",
    es: "Sensación de extrañeza en un país / cultura nueva",
  },
  days,
});

export default feelingForeignInANewCountryCultureBlueprintEs;
